
export const REQUIRED_ERROR = 'REQUIRED_ERROR';